<template>
    <v-container>
        <progress-overlay :Loading="Loading"></progress-overlay>
        <v-card>
            <v-data-table :headers="headerData"
                          :items="tableData"
                          :search="search"
                          dense>
                <template v-slot:top>
                    <v-toolbar flat>
                        <v-toolbar-title>User Management</v-toolbar-title>
                        <v-divider class="mx-4"
                                   inset
                                   vertical></v-divider>
                        <v-text-field v-model="search"
                                      append-icon="mdi-magnify"
                                      label="Search"
                                      single-line
                                      hide-details></v-text-field>
                        <v-spacer></v-spacer>
                        <!--<v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn dark
                                       class="mb-2"
                                       v-bind="attrs"
                                       v-on="on"
                                       @click="syncUsersFromOkta">
                                    Sync Users From Okta
                                </v-btn>
                            </template>
                            <span>Last Updated On: {{ lastOktaUsersSyncDate }}</span>
                        </v-tooltip>-->
                        <v-dialog v-model="dialog"
                                  max-width="1000px"
                                  max-height="1000px">
                            <template v-slot:activator="{ on, attrs }">
                            </template>
                            <v-card>
                                <v-card-title>
                                    <span class="text-h5">Add/Edit User Contracts</span>
                                </v-card-title>
                                <v-card-text>

                                    <v-container>
                                        <v-row>
                                            <v-col cols="12"
                                                   sm="6">
                                                <v-text-field v-model="editedItem.name"
                                                              label="Name"
                                                              filled
                                                              readonly>
                                                </v-text-field>

                                            </v-col>

                                            <v-col cols="12"
                                                   sm="6">
                                                <v-text-field v-model="editedItem.userName"
                                                              label="User Name"
                                                              filled
                                                              readonly>
                                                </v-text-field>
                                            </v-col>

                                        </v-row>
                                        <v-row>
                                            <v-col cols="12">
                                                <v-combobox v-model="selectedHealthPlan"
                                                            :items="healthPlanData" item-text="clientName" item-value="clientID" dense
                                                            label="Select a Health Plan"
                                                            @change="getContractList()"></v-combobox>
                                            </v-col>

                                        </v-row>
                                        <v-row>
                                            <v-col cols="12">
                                                <v-select v-model="selectedcontractList"
                                                          :items="contractList" item-text="displayName" item-value="contractID"
                                                          chips
                                                          label="Select Contracts"
                                                          multiple>
                                                </v-select>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-3"
                                           text
                                           @click="save" small :disabled="issaveButtonDisabled">
                                        Save
                                    </v-btn>
                                    <v-btn color="grey darken-1"
                                           text
                                           @click="close" small>
                                        Cancel
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                        <v-dialog v-model="dialogDelete" max-width="1000px">
                            <v-card>
                                <v-card-title class="text-h8">Are you sure you want delete the Health Plan and Contracts associated with this user? </v-card-title>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn small dark color="blue darken-3" text @click="deleteItemConfirm">OK</v-btn>
                                    <v-btn small dark color="grey darken-1" text @click="closeDelete" >Cancel</v-btn>
                                    <v-spacer></v-spacer>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-toolbar>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon small
                                    class="mr-2"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="editItem(item)">
                                mdi-pencil
                            </v-icon>
                        </template>
                        <span>Add/Edit Health Plan & Contracts </span>
                    </v-tooltip>
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon small
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="deleteItem(item)">
                                mdi-delete
                            </v-icon>
                        </template>
                        <span>Delete Health Plan & Contracts Details </span>
                    </v-tooltip>
                </template>
            </v-data-table>
        </v-card>
    </v-container>
</template>
<script>

    import { mapState } from 'vuex';
    import OktaUserDetails from '../../../Helpers/OktaUserDetails'
    import ProgressOverlay from '../Shared/_partial/ProgressOverlay'

    export default {
        name: "UserManagement",
        components: {
            ProgressOverlay
        },
        data: () => ({
            dialog: false,
            dialogDelete: false,
            search: '',
            Loading: false,
            selectedcontractList: [],
            selectedHealthPlan: [],
            editedItem: {
                userID: '',
                name: '',
                userName: '',
                email: '',
                status: '',
                roles: '',
                clientID: 0,
                healthPlanName: '',
                contractList: '',
            },

        }),
        computed: {
            ...mapState({
                headerData: state => state.UserManagementStore.headerData,
                tableData: state => state.UserManagementStore.tableData,
                healthPlanData: state => state.UserManagementStore.healthPlanData,
                contractList: state => state.UserManagementStore.contractList,
                lastOktaUsersSyncDate: state => state.UserManagementStore.lastOktaUsersSyncDate,

            }),
            issaveButtonDisabled() {
                return !(this.selectedcontractList.length !== 0);

            },
        },
        methods: {
            getTableData() {
                this.Loading = true;
                this.$store.dispatch('UserManagementStore/getTableData')
                    .then(() => {
                        this.Loading = false;
                    }).catch(error => {
                        this.Loading = false;
                        this.$store.dispatch('AppStore/SetAlert', { alert: error, isError: true })
                    })
            },
            isInternalAdmin() {
                const oktaUserDetails = new OktaUserDetails();
                let rolename = process.env.VUE_APP_ADMIN_ROLE_NAME;
                let internalAdmin = oktaUserDetails.getUserRoles().filter(role => role.toLowerCase() == rolename.toLowerCase());
                if (internalAdmin.length > 0) return true;
                else return false;
            },
            syncUsersFromOkta() {
                this.Loading = true;
                this.$store.dispatch('UserManagementStore/syncUserDetailsFromOkta')
                    .then(() => {
                        this.$store.dispatch('UserManagementStore/getTableData');
                        this.Loading = false;
                    }).catch(error => {
                        this.Loading = false;
                        this.$store.dispatch('AppStore/SetAlert', { alert: error, isError: true })
                    })
            },
            getAllHealthPlans() {
                this.Loading = true;
                this.$store.dispatch('UserManagementStore/getAllHealthPlanNames')
                    .then(() => {
                        this.Loading = false;
                    }).catch(error => {
                        this.Loading = false;
                        this.$store.dispatch('AppStore/SetAlert', { alert: error, isError: true })
                    })
            },
            getContractList() {

                if (isNaN(this.selectedHealthPlan.clientID) === false) {

                    this.clientid = this.selectedHealthPlan.clientID;
                }
                else {
                    this.clientid = 0;
                }
                this.selectedcontractList = [];
                this.Loading = true;
                this.$store.dispatch('UserManagementStore/getContractList', { clientid: this.clientid })
                    .then(() => {

                        this.Loading = false;
                    }).catch(error => {
                        this.Loading = false;
                        this.$store.dispatch('AppStore/SetAlert', { alert: error, isError: true })
                    }
                    )

            },
            editItem(item) {

                this.selectedcontractList = [];
                this.editedIndex = this.tableData.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true

                this.selectedHealthPlan = {
                    clientID: this.editedItem.clientID,
                    clientName: this.editedItem.healthPlanName
                }

                if (this.editedItem.clientID > 0) {
                    this.getContractList();
                }
                if (this.editedItem.contractList.length > 0) {

                    var listofcontracts = this.editedItem.contractList.split(",").map(function (item) {
                        return item.trim();
                    });
                    this.selectedcontractList = listofcontracts;
                }
            },
            deleteItem(item) {
                this.editedIndex = this.tableData.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialogDelete = true
            },

            deleteItemConfirm() {

                this.selectedHealthPlan = {
                    clientID: 0,
                    clientName: ''
                }
                this.selectedcontractList = [];

                this.save();
                this.getAllHealthPlans()
                this.$store.dispatch('UserManagementStore/resetSelectedContract');
                this.closeDelete();
            },

            close() {
                this.dialog = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
                this.selectedcontractList = [];
                this.$store.dispatch('UserManagementStore/resetSelectedContract');
            },

            closeDelete() {
                this.dialogDelete = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
            },

            save() {
                this.Loading = true;
                this.$store.dispatch('UserManagementStore/saveContractDetails', { clientid: this.selectedHealthPlan, contractlist: this.selectedcontractList, userid: this.editedItem.userID })
                    .then(() => {

                        this.Loading = false;
                    }).catch(error => {
                        this.Loading = false;
                        this.$store.dispatch('AppStore/SetAlert', { alert: error, isError: true })
                    }
                    )

                this.editedItem.healthPlanName = this.selectedHealthPlan.clientName;
                this.editedItem.clientID = this.selectedHealthPlan.clientID;
                this.editedItem.contractList = this.selectedcontractList.join(',');

                if (this.editedIndex > -1) {
                    Object.assign(this.tableData[this.editedIndex], this.editedItem)
                } else {
                    this.tableData.push(this.editedItem)
                }

                this.close()
            
            }


        },
        created() {
            if (!this.isInternalAdmin()) {
                this.$router.push('/UnAuthorized');
            }
            else {
                this.getTableData();
                this.getAllHealthPlans();
            }
        },
        mounted() { }
    }
</script>